export const teamLeaders = [
	'myyntipaeaellikkoe',
	'etupalvelupaeaellikkoe',
	'telepaeaellikkoe',
];

export const adminRoles = ['admin'];
